export const DEPARTMENT_API_PATHS = {
  GET_DEPARTMENTS: "v1/organization/{0}/departments/",
  CREATE_DEPARTMENT: "v1/organization/{0}/department/create-or-update/",
  UPDATE_DEPARTMENT: "v1/organization/{0}/department/create-or-update/",
  PATCH_DEPARTMENT_STATUS: "v1/organization/{0}/department/{1}/status/",
  DELETE_DEPARTMENT: "v1/organization/{0}/department/{1}/delete",
};
